<template>
  <div>
    <h1 class="main-title">{{ text['0001'] }}</h1>
    <p class="main-text">
      {{ text['0042'] }}
    </p>
    <div class="splash">
      <img :src="`/assets/img/splash_${currentLanguage}.png`" @click="screenSplashNext" class="splash">
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        text: 'getText',
        currentLanguage: 'getLanguageLowerCase',
      }),
    },
    methods: {
      ...mapActions({
        screenSplashNext: 'navigation/screenSplashNext',
      }),
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/screens/Splash.vue